<template>
  <div>
    <!-- <v-alert color="error" icon="error" class="ma-0 pa-2" outline :value="!isServiceActive">
      <div class="primary--text">
        Sorry, the report generation service could not be reached right now. Please reload the page in a few minutes &mdash; let us know
        if the issue persists!
      </div>
    </v-alert> -->
    <v-alert v-if="!wizardMode" mode="fade" color="warning" icon="warning" class="ma-0 pa-2" outline :value="!hasMadeSelection">
      <div class="primary--text">
        <div v-if="!hasSelectedAnalyte && !hasSelectedStation">
          Select an <strong>analyte</strong> and a <strong>station</strong> to download.
        </div>
        <div v-else-if="!hasSelectedAnalyte">
          Select an <strong>analyte</strong> to download.
        </div>
        <div v-else-if="!hasSelectedStation">
          Select a <strong>station</strong> to download.
        </div>
      </div>
    </v-alert>
    <v-alert v-if="!wizardMode" mode="fade" color="info" icon="info" class="ma-0 pa-2" outline :value="hasUnsavedChanges">
      <div class="primary--text">
        <div v-if="!hasQuery">
          Your query is not saved yet.
        </div>
        <div v-else>
          Your changes have not been saved yet.
          <span v-if="mustSaveMissingParams"> The missing parameters are removed after saving. </span>
        </div>
      </div>
    </v-alert>
    <v-alert mode="fade" color="warning" icon="warning" class="ma-0 pa-2" outline :value="hasMissingParams">
      <div class="primary--text">
        Some parameters could not be loaded and might be deprecated.
        <v-btn small @click="$emit('showMissingParams')">
          {{$t('Button.ViewDetails')}}
        </v-btn>
      </div>
    </v-alert>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'

  export default {
    props: {
      mustSaveMissingParams: Boolean,
      hasSelectedStation: Boolean,
      hasSelectedAnalyte: Boolean,
      hasMadeSelection: Boolean,
      hasUnsavedChanges: Boolean,
      isQuerySaved: Boolean,
      hasQuery: Boolean,
      wizardMode: Boolean,
    },
    computed: {
      ...mapGetters('multistation', ['missingParams']),
      hasMissingParams() {
        return Object.values(this.missingParams).some(param => param.length > 0)
      },
    },
  }
</script>